import * as React from 'react';
import { Unstable_Popup as BasePopup } from '@mui/base/Unstable_Popup';
import { useEffect } from "react";

const PopupWithActions = ({ anchor, open, onClose, children, handleClose, shadow, placement = 'bottom-start' }) => {
  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (open && anchor && !anchor.contains(event.target)) {
        handleClose();
      }
    };

    document.addEventListener('click', handleDocumentClick);

    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, [open, anchor]);
  return (
    <BasePopup anchor={anchor} open={open} onClose={onClose} withTransition placement={placement} className="z-20 border-0 rounded-2xl">
      <div className={`bg-paper border border-divider mt-2 ${shadow?.length > 0 ? shadow : "shadow-sm"} rounded-md`}>
        {children}
      </div>
    </BasePopup>
  )
}

export default PopupWithActions;
